import { render } from "./FourOFour.vue?vue&type=template&id=3b15b220&scoped=true"
import script from "./FourOFour.vue?vue&type=script&lang=js"
export * from "./FourOFour.vue?vue&type=script&lang=js"

import "./FourOFour.vue?vue&type=style&index=0&id=3b15b220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b15b220"]])

export default __exports__